import { hotkeys } from 'react-keyboard-shortcuts';
import withWidth from '@material-ui/core/withWidth';
import Tooltip from '@material-ui/core/Tooltip';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import LeftArrowIcon from '@material-ui/icons/KeyboardArrowLeft';
import RightArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { UserConsumer } from './providers/UserProvider';

const styles = {
  list: {
  },
  firstItem: {
    height: 36,
    paddingLeft: 12,
    borderTop: 'solid 1px #aaa',
    '&:focus-visible': {
      outline: 'dashed 4px white'
    }
  },
  firstItemSelected: {
    height: 36,
    paddingLeft: 12,
    borderTop: 'solid 1px #aaa',
    backgroundColor: '#3479af',
    '&:focus-visible': {
      outline: 'dashed 4px white'
    }
  },
  listItem: {
    paddingLeft: 12,
    height: 36,
    '&:focus-visible': {
      outline: 'dashed 4px white'
    }
  },
  listItemSelected: {
    paddingLeft: 12,
    height: 36,
    backgroundColor: '#3479af',
    '&:focus-visible': {
      outline: 'dashed 4px white'
    }
  },
  buttonIcon: {
    height: 30,
    color: 'white'
  },
  divider: {
    borderBottom: 'solid 1px #aaa'
  },
  sideBarIcon: {
    width: 30,
    marginTop: 2,
    minWidth: 30,
    color: 'white',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  sideBarText: {
    color: 'white',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  sideDrawerOpen: {
    position: 'absolute',
    backgroundColor: '#01579b',
    width: 250,
    top: 64,
    paddingTop: 28,
    botton: 0
  },
  sideDrawerClosed: {
    position: 'absolute',
    backgroundColor: '#01579b',
    width: 50,
    top: 64,
    paddingTop: 28,
    bottom: 0
  },
  buttonOpen: {
    position: 'absolute',
    backgroundColor: '#01579b',
    width: 26,
    height: 32,
    left: 250,
    paddingTop: 3,
    borderLeft: 'solid 1px #aaa',
    top: 37,
    '&:hover': {
      cursor: 'pointer'
    },
    '&:focus-visible': {
      outline: 'dashed 4px black'
    }
  },
  buttonClosed: {
    position: 'absolute',
    backgroundColor: '#01579b',
    width: 26,
    height: 32,
    left: 50,
    paddingTop: 3,
    borderLeft: 'solid 1px #aaa',
    top: 37,
    '&:hover': {
      cursor: 'pointer'
    },
    '&:focus-visible': {
      outline: 'dashed 4px black'
    }
  },
  innerBackOpen: {
    zIndex: -999,
    position: 'fixed',
    backgroundColor: '#01579b',
    top: 0,
    bottom: 0,
    left: 0,
    width: '250px'
  },
  innerBackClosed: {
    zIndex: -999,
    position: 'fixed',
    backgroundColor: '#01579b',
    top: 0,
    bottom: 0,
    left: 0,
    width: '50px'
  }
};

class SideDrawer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    };
    this.barRef = React.createRef();
  }

  hot_keys = {
    'alt+b': {
      priority: 1,
      handler: () => {
        if (this.barRef && this.barRef.current) {
          this.barRef.current.focus();
        }
      }
    }
  };

  onSelect(link) {
    this.props.history.push(link);
  }

  render() {

    const { classes, isOpen, toggleDrawer, baseURL, options, optionParams, width } = this.props;

    const drawerClass = isOpen ? classes.sideDrawerOpen : classes.sideDrawerClosed;
    const drawerButtonClass = isOpen ? classes.buttonOpen : classes.buttonClosed;
    const backClass = isOpen ? classes.innerBackOpen : classes.innerBackClosed;
    const urlFragment = this.props.location.pathname;

    return (
      <UserConsumer>
        {({ entitlements, hideRelease, user, hideMaintenance }) =>
          <div
            role="complementary"
            data-test="side-drawer"
            id="side-drawer"
            className={drawerClass}
            style={(user.adminWindow && user.adminWindow.startTime && !hideMaintenance) || (!hideRelease) ? { top: '102px' } : {}}>
            <div className={backClass} />
            {width !== "xs" &&
              <div
                tabIndex={0}
                ref={this.barRef}
                data-test="show-hide"
                className={drawerButtonClass}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    ev.stopPropagation();
                    toggleDrawer();
                  }
                }}
                onClick={toggleDrawer}>
                {isOpen ?
                  <LeftArrowIcon className={classes.buttonIcon} />
                  :
                  <RightArrowIcon className={classes.buttonIcon} />}
              </div>
            }
            <List data-test="sidebar-options" classes={{
              root: classes.list
            }}>
              {options.map((option, index) => {
                if (option.entitlement) {
                  const optionEntitlements = Array.isArray(option.entitlement) ? option.entitlement : [option.entitlement];
                  const allowed = entitlements.some(entitlement => optionEntitlements.includes(entitlement));
                  if (!allowed) return null;
                }
                const itemUrl = baseURL + "/" + option.url;
                const isSelected = urlFragment === itemUrl;
                const styleClass = (index === 0 ? 'firstItem' : 'listItem') + (isSelected ? "Selected" : "");
                return <ListItem
                  key={index}
                  tabIndex={0}
                  data-test={"option-" + option.name}
                  onKeyDown={(ev) => {
                    if (ev.key === "Enter") {
                      ev.preventDefault();
                      ev.stopPropagation();
                      this.onSelect(itemUrl + optionParams);
                    }
                  }}
                  dense
                  divider
                  classes={{
                    root: classes[styleClass],
                    divider: classes.divider
                  }}>
                  <ListItemIcon onClick={() => this.onSelect(itemUrl + optionParams)}
                    classes={{
                      root: classes.sideBarIcon
                    }}>
                    {isOpen ?
                      <div>
                        {option.icon}
                      </div>
                      :
                      <Tooltip title={option.name}>
                        <div>
                          {option.icon}
                        </div>
                      </Tooltip>
                    }
                  </ListItemIcon>
                  {isOpen &&
                    <ListItemText
                      data-test="option-text"
                      className={classes.sideBarText}
                      onClick={() => this.onSelect(itemUrl + optionParams)}
                      primary={option.name} />
                  }
                </ListItem>;
              }
              )}
            </List>
          </div>
        }
      </UserConsumer>
    );
  }
}

SideDrawer.defaultProps = {
  optionParams: ""
};

SideDrawer.propTypes = {
  location: PropTypes.object,
  isOpen: PropTypes.bool,
  history: PropTypes.object,
  options: PropTypes.array.isRequired,
  optionParams: PropTypes.string.isRequired,
  baseURL: PropTypes.string.isRequired,
  classes: PropTypes.object
};

export default withWidth()(withStyles(styles)(withRouter(hotkeys(SideDrawer))));